// conversion factor
export const knotsToMs = 1.94384;

export const convertNestedValuesToKt = (
  nestedValue: number | { max: number | null; min: number | null } | null
) => {
  if (nestedValue === null) return null;
  if (typeof nestedValue === "number") {
    return parseFloat((nestedValue * 1.94384).toFixed(1));
  }
  return {
    max:
      nestedValue.max !== null ? parseFloat((nestedValue.max * 1.94384).toFixed(1)) : null,
    min:
      nestedValue.min !== null ? parseFloat((nestedValue.min * 1.94384).toFixed(1)) : null,
  };
};

export const convertNestedValuesToMs = (
  nestedValue: number | { max: number | null; min: number | null } | null
) => {
  if (nestedValue === null) return null;
  if (typeof nestedValue === "number") {
    return parseFloat((nestedValue / 1.94384).toFixed(1));
  }
  return {
    max:
      nestedValue.max !== null ? parseFloat((nestedValue.max / 1.94384).toFixed(1)) : null,
    min:
      nestedValue.min !== null ? parseFloat((nestedValue.min / 1.94384).toFixed(1)) : null,
  };
};

export const keysToConvert = [
  "Wind10M",
  "Wind50M",
  "WindGusts10M",
  "WindGusts50M",
  "RiskWindSpeed",
];
